import { backdropAtom } from '@/commons/constants';
import { useSetAtom } from 'jotai';
import { useEffect } from 'react';

export default function Report() {
  const setBackdrop = useSetAtom(backdropAtom);
  useEffect(() => {
    setBackdrop(false);
  }, []);
  return <div>NOT YET Report</div>;
}
